module.exports = __webpack_public_path__ + "static/plain-funcionalidades2-3d3f7ba42234a094d3e474c5d025df0b.png";